import { memo } from 'react';

import type { LbPart } from '../../types';

const VideoPost = ({ part: { data } }: { part: LbPart }) => <div>Video Post: {data?.Id}</div>;

export default memo(VideoPost);
